<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import staticLookups from "@/js/staticLookups";

const store = useStore();
const currentTime = ref(Date.now());

onMounted(() => {
    setInterval(() => {
        currentTime.value = Date.now();
    }, 100)
})

</script>

<template>
  <div class = "toast-overlay">
    <transition name = "fade">
        <div class = "background" v-if = "store.getters.currentToast != null"></div>
    </transition>
    <div class = "toast-area flex-center">
        <transition name = "slideup-fade">
            <div class = "toast" v-if = "store.getters.currentToast != null">
                <div class = "toast-modal-card" v-if = "store.getters.currentToast.type == 'card'">
                    <div class = "overlay-border"></div>
                    <img class = "card-image" :src = "store.getters.currentToast.cardImage">
                    <div class = "title">
                        {{store.getters.currentToast.title }}
                    </div>
                    <div class = "subtitle">
                        {{store.getters.currentToast.subtitle }}
                    </div>
                </div>
                <div class = "toast-modal-minimal" v-if = "store.getters.currentToast.type == 'minimal'">
                    <div class = "overlay-border"></div>
                    <img class = "icon-image" :src = "store.getters.currentToast.iconImage">
                    
                    <div class="title">
                        {{ store.getters.currentToast.title }}
                    </div>
                        
                </div>
                <template v-if="store.getters.currentToast.type == 'race-leader'">
                       <div class="notification" >
                            <div class="text">
                                New Race Leader
                            </div>
                        </div>
                        <div class="toast-modal-race-leader">
                            <div class="overlay-border"></div>
                            <img class="icon-image"
                                :src="`https://cf.nascar.com/data/images/carbadges/1/${store.getters.currentToast.data.veh.no}.png`"
                                alt="">
                            <div class="text-area">
                                <div class="subtitle">
                                    {{ `${store.getters.currentToast.data.drv.f_nm}
                                    ${store.getters.currentToast.data.drv.l_nm}` }}
                                </div>
                                <div class="team">
                                    {{ staticLookups.teamData[store.getters.currentToast.data.own.id].name }}
                                </div>

                            </div>
                        </div>
                </template>

                <div class="toast-modal-minimal" v-else-if="store.getters.currentToast.type == 'flag-change'">
                        <div class="flag-icon-image" :style = "{
                            'background-color': staticLookups.flags[store.getters.currentToast.data.flg]?.color, 
                            'fill': staticLookups.flags[store.getters.currentToast.data.flg]?.color, 
                            'mask-image': `url(${staticLookups.flags[store.getters.currentToast.data.flg]?.image})` }"
                        />

                        <div class="title">
                            Flag Change
                        </div>
                </div>
                
                <div class = "timer-bar">
                    <div class = "fill" :style = "{'transform': `translateX(${-(1-(currentTime-store.getters.currentToast.timeStart)/store.getters.currentToast.duration)*100}%)`}"></div>
                </div>
            </div>
        </transition>
    </div>

  </div>
</template>

<style lang="scss" scoped>

@import '../sass/GlobalClasses';
@import '../sass/Settings';

.slideup-fade-enter-active, .slideup-fade-leave-active
{
  transition: all .6s ease;
}

.slideup-fade-enter-from, .slideup-fade-leave-to
{
  transform: translateY(200%);
  opacity: 0;
}

.toast-overlay{
    @extend %fixed-fill;
    z-index: 1;
    color: white;

    .background{
        @extend %absolute-fill;
        background-color: black;
    }

    .toast-area{
        position: absolute;
        height: vw(353);
        bottom: vw(120);
        left: vw(90);
        right: vw(90);

        .toast{
            position: relative;
            width: vw(420);
            height: fit-content;

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .notification {
                position: relative;
                height: vw(44);
                width: fit-content;
                padding: vw(8) vw(30) vw(6) vw(30);
                background-color: #007AC2;
                margin-bottom: vw(18);
                border-radius: vw(5);
                
                .text{
                    position: relative;
                    font-size: vw(24);
                    color: white;
                    font-weight: 400;
                }
            }

            .timer-bar{
                position: relative;
                width: vw(213);
                height: vw(6);
                border-radius: vw(3);
                margin-top: vw(20);
                overflow: hidden;

                background-color: #666666;

                .fill{
                    position: relative;
                    width: 100%;
                    height: 100%;
                    background-color: #FCFCFC;
                    transition: all linear 0.2s;
                }
            }

            .toast-modal-card{
                position: relative;
                width: vw(420);
                height: fit-content;
                background-color: #1C1C1E;
                border-radius: vw(15);

                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;

                padding-left: vw(15);
                padding-right: vw(15);
                padding-top: vw(15);
                padding-bottom: vw(30);

                .card-image{
                    position: relative;
                    width: vw(388);
                }

                .title{
                    position: relative;
                    font-size: vw(28);
                    margin-top: vw(15);
                }

                .subtitle{
                    position: relative;
                    font-size: vw(24);
                    margin-top: vw(5);
                }
            }

            .toast-modal-minimal{
                position: relative;
                width: vw(420);
                height: fit-content;
                background-color: #818181;
                border-radius: vw(15);

                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                padding: vw(25);

                .icon-image{
                    position: relative;
                    width: vw(56);
                }

                .flag-icon-image {
                    position: relative;
                    width: vw(32);
                    height: vw(32);
                    margin-right: vw(10);

                    /* Core layout rules for the mask layer */
                        mask-size: contain;
                        mask-repeat: no-repeat;
                        mask-position: center;
                    
                        /* Webkit prefix overrides for Chrome, Safari, and Edge browser support */
                        -webkit-mask-size: contain;
                        -webkit-mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                }

                .right-section{
                    position: relative;
                    padding-left: vw(20);

                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    .title {
                        position: relative;
                        font-size: vw(28);
                        font-weight: 700;
                    }

                    .team {
                        position: relative;
                        font-size: vw(28);
                        font-weight: 700;
                    }
                }

                
            }

            .toast-modal-race-leader{
                position: relative;
                width: vw(420);
                height: fit-content;
                background: linear-gradient(132.96deg, rgb(100, 100, 100) -27.09%, rgb(40, 40, 40) 27.74%, rgba(65, 65, 65) 99.43%);
                border-radius: vw(10);

                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                padding: vw(25);

                .icon-image{
                    position: relative;
                    width: vw(56);
                }

                .text-area{
                    position: relative;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;

                    padding-left: vw(20);

                    .title{
                        position: relative;
                        font-size: vw(28);
                        font-weight: 700;
                        text-align: left;
                    }

                    .team {
                        position: relative;
                        font-size: vw(24);
                        font-weight: 700;
                        text-align: left;
                        color: #D9D9D9;
                        margin-top: vw(5);
                    }

                    .subtitle{
                        position: relative;
                        font-size: vw(24);
                        padding: 0;
                        text-align: left;
                    }
                }

                .title{
                    position: relative;
                    font-size: vw(28);
                    margin-left: vw(15);
                }
            }

        }
    }
    
}

</style>
